var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52699 0.850915L0.230873 13.3485C0.0804442 13.6158 0.000849055 13.9188 6.75527e-06 14.2275C-0.000835544 14.5361 0.0771043 14.8396 0.226072 15.1078C0.37504 15.3759 0.589844 15.5994 0.849112 15.7559C1.10838 15.9125 1.40308 15.9966 1.70388 16H16.2961C16.5969 15.9966 16.8916 15.9125 17.1509 15.7559C17.4102 15.5994 17.625 15.3759 17.7739 15.1078C17.9229 14.8396 18.0008 14.5361 18 14.2275C17.9992 13.9188 17.9196 13.6158 17.7691 13.3485L10.473 0.850915C10.3194 0.591159 10.1032 0.376397 9.84521 0.227349C9.5872 0.0783014 9.2961 0 9 0C8.7039 0 8.41281 0.0783014 8.15479 0.227349C7.89678 0.376397 7.68056 0.591159 7.52699 0.850915V0.850915Z",
    fill: "#FF3636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.39392V9.81314",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.4646H9.00924",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.c617e45e484dd366dafd326e3ba2ea20.svg";
export { ForwardRef as ReactComponent };